import $ from 'jquery';
import ajaxHttpHeaders from '@/lib/ajaxHttpHeaders';
import appConfig from '@/lib/appConfig';
import DataTable from 'datatables.net-bs5';
import populateFuels from '@/lib/populateFuels';
import urlParam from '@/lib/urlParam';

var engine_compare_id_list = [];
var MAX_NUMBER_COMPARE_LIST_ITEMS = 4;

window.remove_engine_compare_item = function(id) {
  $('#close_'+id).parent().remove();
  var index = engine_compare_id_list.indexOf(id.toString());
  if (index > -1) {engine_compare_id_list.splice(index, 1);}
  $('input[name="compare_engine_ids[]"][value='+id+']').prop('checked', false);
  if (engine_compare_id_list.length == 0) {
    $('#compare_block').css('display', 'none');
  }
};

function results_engine_params() {
  // Build param list for a URL
  var str = "&current=true&display_length="+$(".dt-length select").val();
  // Collect all the fuels
  var all_fuels_checked = $('#all_fuels:checked').length ? $('#all_fuels').val() : '';
  if (all_fuels_checked == '') {
    var fuel_ids = '';
    $('input[name="fuel_ids[]"]:checked').each(function() {
      fuel_ids += this.value+ ',';
    });
    str += "&fuel_id=" + fuel_ids + "-1";
  } else str += '&all_fuels=y';

  // Collect all the categories
  var all_manufacturers_checked = $('#all_manufacturers:checked').length ? $('#all_manufacturers').val() : '';
  if (all_manufacturers_checked == '') {
    var manufacturer_ids = '';
    $('input[name="manufacturer_ids[]"]:checked').each(function() {
      manufacturer_ids += this.value+ ',';
    });
    str += "&manufacturer_id=" + manufacturer_ids + "-1";
  }  else str += '&all_manufacturers=y';
  return str;
}

function engine_url() {
  return `${appConfig.api_url_root}/v1/heavy_duty_engines.json?current=true${results_engine_params()}`;
}

function update_engine_results() {
  $("#engine_result_spinner").show();
  var delay = 750;
  window.ajaxEngineSendTime = Date.now()+delay;
  var url =  results_engine_params();
  history.replaceState({}, "", "?" + url);
  window.gridEngineUrl = "/vehicles/search/engine_power_source?" + url;
  // Update the search results
  window.ajaxEngineUrl = engine_url();
  window.setTimeout(function(){delayed_update_engine_results()}, (delay));
}

function delayed_update_engine_results(){
  if (Date.now() >= window.ajaxEngineSendTime) {
    if (window.datatableEngineAjax) {
      window.datatableEngineAjax.abort();
    }
    const table = new DataTable('#engine_table', { retrieve: true });
    table.ajax.url(window.ajaxEngineUrl).load();
  }
}

function populate_engine_manufacturers() {
  var hd_mans = $("#manufacturer_search input[name='manufacturer_ids[]']:checked");
  // check for all checked
  if (hd_mans.length == $("#manufacturer_search input[name='manufacturer_ids[]']").length) {
    $("#manufacturer_name").html("All");
  } else if (hd_mans.length == 0) {
    $("#manufacturer_name").html("None");
  } else {
    var mans = [];
    $.each( hd_mans, function(num, elem) {
      try {
        mans[num] = $(elem).siblings(".facet_label").text().trim();
      } catch (e) {
        mans[num] = $(elem).siblings(".facet_label").text();
      }
    });
    $("#manufacturer_name").html(mans.join(", "));
  }
}

function calculate_engine_page_count() {
  var total = parseInt($("#vehicle_count").val());
  var page_size = parseInt($(".dt-length select").val());
  var page = parseInt($(".dt-paging .active").text());
  if (total == 0) {
    $(".num-engines").text(total+" power sources");
  } else {
    var start = ((page-1)*page_size)+1;
    var end = (start+page_size) - 1;
    if ( end > total ) { end = total; }
    if (!(isNaN(start) || isNaN(end))) {
      $(".num-engines").text(start+" - "+end+" of "+total+" power sources");
    }
  }
}

function toggle_engine_results_view() {
  if ($("#vehicle_count").val() == '0' || $("#vehicle_count").val() == '') {
    $("#result_count_0").show();
    $('#engine_view').hide();
  } else {
    $("#result_count_0").hide();
    $('#engine_view').show();
  }
}

$(document).ready(function() {
  toggle_engine_results_view();
  if (urlParam('ids')) {
    engine_compare_id_list = urlParam('ids').split(",");
  }
  $('#all_fuels').click(function() {
    if ($(this).prop('checked') == true) {
      $('input[name="fuel_ids[]"]').prop('checked', true);
    } else {
      $('input[name="fuel_ids[]"]').prop('checked', false);
    }
  });
  $('#all_categories').click(function() {
    if ($(this).prop('checked') == true) {
      $('input[name="category_ids[]"]').prop('checked', true);
    } else {
      $('input[name="category_ids[]"]').prop('checked', false);
    }
  });
  $('#all_manufacturers').click(function() {
    if ($(this).prop('checked') == true) {
      $('input[name="manufacturer_ids[]"]').prop('checked', true);
    } else {
      $('input[name="manufacturer_ids[]"]').prop('checked', false);
    }
  });
  $('.update_engine_results_button').click(function() {
    update_engine_results();
  });

  if ($("#manufacturer_search .fuel-select").length == $("#manufacturer_search .fuel-select input:checked").length) {
    $('#all_manufacturers').prop('checked', true);
  } else {
    $('#all_manufacturers').prop('checked', false);
  }
  if ($("#fuel_tech_search .fuel-select").length == $("#fuel_tech_search .fuel-select input:checked").length) {
    $("#all_fuels").prop('checked', true);
  } else {
    $("#all_fuels").prop('checked', false);
  }
  $('.facet').click(function() {
    const name = $(this).attr('name');
    if (name === 'manufacturer_ids[]') {
      if ($("#manufacturer_search .fuel-select").length == $("#manufacturer_search .fuel-select input:checked").length) {
        $('#all_manufacturers').prop('checked', true);
      } else {
        $('#all_manufacturers').prop('checked', false);
      }
    }
    if (name === 'fuel_ids[]') {
      if ($("#fuel_tech_search .fuel-select").length == $("#fuel_tech_search .fuel-select input:checked").length) {
        $("#all_fuels").prop('checked', true);
      } else {
        $("#all_fuels").prop('checked', false);
      }
    }
    update_engine_results();
  });
  $('.compare_button').click(function() {
    if (engine_compare_id_list.length > MAX_NUMBER_COMPARE_LIST_ITEMS) {
      alert('You may only select ' + MAX_NUMBER_COMPARE_LIST_ITEMS + ' vehicles to compare.');
      return false;
    } else if (engine_compare_id_list.length > 0) {
      $(this).attr("cursor", "pointer");
      // Collect all the vehicle ids
      var ids = engine_compare_id_list.join(',');

      window.location.href = "/vehicles/search/compare?"+results_engine_params()+"&ids="+ids+'&page_type=engine';
    }
  });
  populate_engine_manufacturers();

  var display_length = parseInt($("#display_length").val());

  new DataTable('#engine_table', {
    retrieve: true,
    "ajax": {
      "cache": "true",
      "dataType": 'JSON',
      "url": engine_url(),
      "headers": ajaxHttpHeaders(),
      "dataSrc": function ( json ) {
        var items = [];
        $.each( json['result'], function( num, obj ) {
          $.each(obj, function(index, value) {
            if (value == null) obj[index] = '';
          });
          // Name
          var name = obj['heavy_duty_manufacturer_name'] + ' - ' + obj['model'];

          // Fuel
          var fuel_name_arr = [];
          $.each( obj['fuels'], function( index, arr ) {
            fuel_name_arr[index] = arr['name'];
          });
          var fuel_name = fuel_name_arr.join(", ");

          var chked = '';

          if ($.inArray(obj['id'].toString(), engine_compare_id_list) >= 0) {
            chked = 'checked';
            $('#compare_block').css('display', 'block');
            $('#compare_block').css('height', 'auto');
            $('#compare_list').html($('#compare_list').html() + "<div class='item_box'>"+name+" <a href='javascript:window.remove_engine_compare_item(\""+ obj['id']+"\");' id='close_" + obj['id']+"' class='close_x'>X</a></div>");
          }
          var compare = '<input type="checkbox" id="compare_engine_ids_" name="compare_engine_ids[]" class="form-check-input" data-name="'+name+'" value="' + obj['id'] + '" ' + chked + '>';

          // Detail row
          var row_after = '<h3>' + obj['heavy_duty_manufacturer_name'] + ' - ' + obj['model'] + '</h3> \
              <div class="row" style="margin-top:4px;padding:10px;"> \
                <div class="col-md-7">';

          if (obj['manufacturer_url'] != '' && obj['manufacturer_url'] != null) {
            row_after += '<div style="float:right;margin-right:12px;"><a href="' + obj['manufacturer_url'] + '">Find a Dealer</a></div>';
          }

          row_after += '<div><a href="http://www.epa.gov/otaq/hwy.htm" target="_blank" rel="noopener noreferrer">Latest EPA certification</a></div>';
          row_after += '<div><a href="http://arb.ca.gov/msprog/onroad/cert/cert.php" target="_blank" rel="noopener noreferrer">Latest CARB certification</a></div>';

          row_after += '</div>';
          if (obj['heavy_duty_vehicles'] != null && obj['heavy_duty_vehicles'].length > 0) {
            row_after += '<div class="col-md-3"><strong>Compatible vehicles:</strong><br>';
            $.each(obj['heavy_duty_vehicles'], function(num, vehicle) {
              const r = Math.floor((Math.random() * 1000) + 1);
              row_after += '<a href="#vehicle_detail_'+r+'" data-name="vehicle detail" data-toggle="modal">'+vehicle['heavy_duty_manufacturer_name'] + ' ' + vehicle['model'] + '</a><br>';
              row_after += '<div class="modal vehicle_detail_modal" id="vehicle_detail_'+r+'"><div class="close" data-dismiss="modal">x</div>';
              row_after += '<strong>'+vehicle['heavy_duty_manufacturer_name']+' '+vehicle['model'] +'</strong><br>';
              if (vehicle['vehicle_categories'] && vehicle['vehicle_categories'] != null && vehicle['vehicle_categories'] != '' && vehicle['vehicle_categories'].length > 0) {
                var cat_str = '';
                $.each(vehicle['vehicle_categories'], function(num, f) {
                  if (cat_str.length > 0) cat_str += ', ';
                  cat_str += f['name'];
                });
                row_after += cat_str+'<hr>';
              }
              if (vehicle['fuels'] && vehicle['fuels'] != null && vehicle['fuels'] != '' && vehicle['fuels'].length > 0) {
                var fuel_str = '';
                $.each(vehicle['fuels'], function(num, f) {
                  if (fuel_str.length > 0) fuel_str += ', ';
                  fuel_str += f['name'];
                });
                row_after += '<strong>Fuel Type(s):</strong> '+fuel_str+'<br>';
              }
              if (vehicle['num_passengers'] && vehicle['num_passengers'] != null && vehicle['num_passengers'] != '')
                row_after += '<strong>Maximum Seating:</strong> '+vehicle['num_passengers']+'<br>';
              if (vehicle['heavy_duty_power_systems'] && vehicle['heavy_duty_power_systems'] != null && vehicle['heavy_duty_power_systems'] != '' && vehicle['heavy_duty_power_systems'].length > 0) {
                var power_str = '';
                $.each(vehicle['heavy_duty_power_systems'], function(num, f) {
                  if (power_str.length > 0) power_str += '<br>';
                  power_str += f['model'];
                });
                row_after += '<strong>Power Source(s):</strong><br><div style="margin-left:12px;">'+power_str+'</div><br>';
              }
            });
            row_after += '</div>';
          }
          row_after += '</div>';

          items.push([`<i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i>${name}`, fuel_name, compare, row_after]);
        });
        populateFuels();
        populate_engine_manufacturers();
        $('#vehicle_count').val(items.length);
        toggle_engine_results_view();
        return items;

      },
      "beforeSend": function (xhr) {
        window.datatableEngineAjax = xhr;
        $("#engine_result_spinner").show();
        $("#engine_table_wrapper").hide();
      }
    },

    "language": {
      info:"Showing _START_ to _END_ of _TOTAL_",
      infoFiltered:"",
      zeroRecords:"No results to display",
      lengthMenu: '<span class="fw-bold me-1">Vehicles per page:</span> _MENU_',
      infoEmpty:"0 results",
    },
    "pageLength": display_length,
    "columns": [
      { width: "400px", "class": 'engine-name' },
      { width: "400px" },
      { width: "80px", "orderable": false, 'class': 'compare_checkbox' },
      { width: 0, "visible": false}
    ],
    layout: {
      topStart: '',
      topEnd: '',
      bottomStart: 'pageLength',
      bottomEnd: {
        paging: {
          firstLast: false,
        },
      },
    },
    "searching": false,
    "processing": false,
    "preDrawCallback": function(){
      // colapse expanded rows
      $("tr.expanded").next().remove();
      $("tr.expanded").removeClass('expanded');
    },
    "drawCallback": function() {
      const table = this.api();

      calculate_engine_page_count();
      var csv_url = "/vehicles/search/engine_power_source.csv?" + results_engine_params();
      $("#engines_csv_download").prop('href', csv_url);
      $("#engine_result_spinner").hide();
      $('#engine_table').css('width', "");
      $("#engine_table_wrapper").show();
      // Add event listener for opening and closing details
      $('#engine_table td').off('click');
      $('#engine_table td').on('click', function(e) {
        if ($(e.target).is('input')) {
          return;
        }
        var row = $(this).parent();
        if (!row.hasClass('expanded')) {
          const pRow = table.row(this).data(); // getting the values in the columns
          row.after('<tr class="detail_row"><td colspan="3" class="card_view_in_list">'+pRow[3]+'</td></tr>');
          row.addClass('expanded');
          row.addClass('highlighted_row');
        } else {
          row.removeClass('expanded');
          row.removeClass('highlighted_row');
          $(this).parent().next().remove();
        }
      });
      $('#engine_table input[name="compare_engine_ids[]"]').off('click');
      $('#engine_table input[name="compare_engine_ids[]"]').on('click', function() {
        if (engine_compare_id_list.length >= MAX_NUMBER_COMPARE_LIST_ITEMS && $(this).prop('checked') == true) {
          alert('You may only select ' + MAX_NUMBER_COMPARE_LIST_ITEMS + ' vehicles to compare.');
          $(this).prop('checked', false);
        } else {
          if ($(this).prop('checked') == true) {
            engine_compare_id_list.push($(this).val());
            $('#compare_block').css('display', 'block');
            $('#compare_block').css('height', 'auto');
            $('#compare_list').html($('#compare_list').html() + "<div class='item_box'>"+$(this).attr('data-name')+" <a href='javascript:window.remove_engine_compare_item(\""+$(this).val()+"\");' id='close_"+$(this).val()+"' class='close_x'>X</a></div>");
          } else {
            window.remove_engine_compare_item($(this).val());
          }
        }
      });
      history.replaceState({}, "", "?" + results_engine_params());
    },
    initComplete: function() {
      // Trigger drawCallbac() after fully initialized as a workaround for
      // pagination not being fully setup during initial draw (this could be
      // cleaned up):
      // https://datatables.net/forums/discussion/79816/datatables-2-paging-dom-only-appears-after-the-drawcallback
      const table = this.api();
      table.draw();
    },
  });
});
